import React, { useState } from 'react';
import _ from "lodash";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";

import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";

import i18n from "i18next";
import { EntCompanyWarehouses } from "../../../../models/chemicalization/companyWarehouses";
import { EntCompanyWarehousesFilter } from "../../../../models/filters/companyWarehousesFilter";
import { useCompanyWarehouses } from "./useCompanyWarehouses";
import {
  useLazyGetCompanyWarehousesListQuery,
  useReportCompanyWarehousesMutation,
} from "../../../../redux/api/chemicalization/companyWarehousesApi";
import { FilterCompanyWarehouses } from "./FilterCompanyWarehouses";
import { AddCompanyWarehousesModal } from "./AddCompanyWarehouses";
import ReportCompanyWarehousesModal from "./ReportСompanyWarehousesModal";

enum FormField {
  warehouseName,
  companyId,
}

export const СompanyWarehouses = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntCompanyWarehouses>(new EntCompanyWarehouses());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()
  const {
	onAddCompanyWarehouses, onDeleteCompanyWarehouses, onEditCompanyWarehouses
  } = useCompanyWarehouses(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isChemAvailable = storedData.some((route: any) => (route.alias === "/departments/chemicalization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const [getArchiveFolders] = useLazyGetCompanyWarehousesListQuery();
  const [getReportСompanyWarehouses] = useReportCompanyWarehousesMutation();

  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntCompanyWarehouses, EntCompanyWarehousesFilter>({
	initialFilter: new EntCompanyWarehousesFilter(),
	query: getArchiveFolders
  });
  const openAddModal = (item: EntCompanyWarehouses) => {
	setSelectedItem(item);
	setShowModal(true);
  };
  const setEntityFromFields = (): EntCompanyWarehousesFilter => {
	let filt: EntCompanyWarehousesFilter = _.clone(filter);
	filt.warehouseName = form.getFieldValue(FormField.warehouseName) ?? null;
	filt.companyId = form.getFieldValue(FormField.companyId) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.warehouseName, value: null },
	  { name: FormField.companyId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const getReport = async (payload: { year: number; language: string }): Promise<Blob> => {
	return await getReportСompanyWarehouses(payload).unwrap();
  };

  const openReportModal = () => {
	setShowReportModal(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('chemicalization.company_warehouses.warehouse_name') }</th>
		  <th>{ t('titles.company') }</th>
		  {/*<th>{ t('chemicalization.company_warehouses.region') }</th>*/ }
		  {/*<th>{ t('mechanisation.total_account.area') }</th>*/ }
		  <th style={ { width: "250px" } }>{ t('titles.territorial_units') }</th>
		  <th>{ t('mechanisation.total_account.address') }</th>
		  <th>{ t('general.fio') }</th>
		  <th>{ t('user.phone_number') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.warehouseName }</td>
			<td>{ item?.company?.companyName }</td>
			{/*<td>{ i18n.language === 'ru' ? item.regionRu : item.regionKy }</td>*/ }
			{/*<td>{ i18n.language === 'ru' ? item.areaRu : item.areaRu }</td>*/ }
			<td>{ i18n.language === 'ru' ? item.territorialUnit?.nameRu : item.territorialUnit?.nameKy }</td>
			<td>{ item?.address }</td>
			<td>{ item?.fio }</td>
			<td>{ item?.phone }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteCompanyWarehouses(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.company_warehouses') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('chemicalization.company_warehouses.company_warehouses_desc') } { t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntCompanyWarehouses())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  { isChemAvailable && (
		<Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> }
				onClick={ () => openReportModal() }>
		  { t('general.generate_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterCompanyWarehouses
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddCompanyWarehousesModal
		companyWarehouses={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		  setSelectedItem(new EntCompanyWarehouses())
		} }
		onSubmit={ selectedItem.id !== null ? onEditCompanyWarehouses : onAddCompanyWarehouses }
	  />
	  <ReportCompanyWarehousesModal
		getReport={ getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  );
}
